module.exports = __webpack_public_path__ + "static/media/acute.ed551913.svg";